import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'
import { isTestCafeAuthEnabled } from '@/helpers/isTestCafeEnabled'

const authPrefix = isTestCafeAuthEnabled()
  ? import.meta.env.VITE_APP_API_BASE_AUTH_TESTCAFE_URL
  : import.meta.env.VITE_APP_API_BASE_AUTH_URL

export default {
  authenticate(payload) {
    const auth = `${authPrefix}authenticate`
    return http.post(auth, payload)
  },
  validate(token) {
    return http.get(endpoints.get('auth', { action: 'validate' }), {
      params: { token }
    })
  },
  logout() {
    return http.post(endpoints.get('auth', { action: 'logout' }))
  },
  refresh() {
    return http.post(endpoints.get('auth', { action: 'refresh' }))
  }
}
